import { Component, Input } from '@angular/core';
import { Heading } from './calculation-form-sidebar-heading.type';

@Component({
  selector: 'app-calculation-form-sidebar-heading',
  templateUrl: './calculation-form-sidebar-heading.component.html',
  styleUrls: ['./calculation-form-sidebar-heading.component.scss'],
  standalone: false,
})
export class CalculationFormSidebarHeadingComponent {
  @Input()
  heading: Heading;
}
